/** InternalBadge — tiny "internal" / "signed in" pill (ink bg, paper text). */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { colors, fontFamily, fontWeight, radii } from '../theme';
import { Lock } from '../icons';

type Props = { label?: string; lock?: boolean };

export default function InternalBadge({ label = 'internal', lock }: Props) {
  return (
    <View style={styles.badge}>
      {lock && <Lock size={10} color={colors.paper} />}
      <Text style={styles.text}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    height: 17,
    paddingHorizontal: 6,
    borderRadius: radii.full,
    backgroundColor: colors.ink,
  } as any,
  text: {
    fontFamily: fontFamily.sans,
    fontSize: 9,
    fontWeight: fontWeight.semibold,
    color: colors.paper as any,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
});
